import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
export default function Login() {
  const { login, error } = useAuth();
  const [searchParams] = useSearchParams();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const u = searchParams.get("u");
    if (u) setIdentifier(u.toLowerCase().replace(/[^a-z0-9._-]/g, ""));
  }, [searchParams]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(identifier, password);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-[#FFFDF8]">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-2xl bg-yellow-400 flex items-center justify-center">
            <Sparkle weight="fill" className="text-yellow-950" size={22} />
          </div>
          <div>
            <div className="font-outfit font-black text-lg leading-none">Alpha AI Discovery Club</div>
            <div className="text-xs text-slate-500">Tema Community 25</div>
          </div>
        </div>

        <h1 className="font-outfit text-4xl sm:text-5xl font-black tracking-tight mb-2">Welcome back.</h1>
        <p className="text-slate-600 mb-8">Sign in to see what's next in class.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm font-medium block mb-1">Email or username</label>
            <input
              type="text"
              required
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              data-testid="login-email-input"
              autoCapitalize="off"
              autoCorrect="off"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="you@school.gh or kwame"
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-btn"
            className="btn-tactile-yellow w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-yellow-400 hover:bg-yellow-500 font-outfit font-bold text-yellow-950 disabled:opacity-60"
          >
            {busy ? "Signing in..." : "Sign in"} <ArrowRight weight="bold" size={18} />
          </button>
        </form>

        <div className="mt-6 text-xs text-slate-500 leading-relaxed" data-testid="no-signup-hint">
          Accounts are created by your teacher. If you have a{" "}
          <span className="font-mono font-semibold text-slate-700">TEMA-XXXX</span> class code,
          use the invite link they shared instead.
        </div>
      </div>
    </div>
  );
}
